<template>

  <div class="wardrobes">

    <div class="wardrobe" v-for="(item, index) in builder.items" :key="index + 1">
      <div class="wardrobe-inner">

        <div class="wardrobe-header l_controllable">
          <div class="wardrobe-title">
            <strong>{{ builder.range.itemName }} {{ index + 1 }}</strong>
            <span v-if="item.product && builder.range.handle == 'wardrobes'" v-html="item.product.title"></span>
            <span v-else-if="item.productLayout && builder.range.handle == 'kitchens'" v-html="item.productLayout.title"></span>
          </div>
          <div class="wardrobe-actions">

          </div>
        </div>

        <component
          :is="getComponent(item)"
          :item="item"
          v-if="item.valid"
          @lightbox-activate="lightboxActivate">
        </component>

        <div class="wardrobe-main l_specs" v-else>

          <div class="wardrobe-specs">

            <div class="wardrobe-spec l_w60">
              <div class="wardrobe-spec-inner">
                <p class="wardrobe-spec-title">Incomplete</p>
                <p class="wardrobe-spec-text">
                  Please edit this <strong v-html="builder.range.itemName" style="text-transform: lowercase;"></strong> to see the details and price.
                </p>
              </div>
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>

  <Adjusters></Adjusters>

  <Totals :is-quote="false"></Totals>

</template>

<script setup>
import { ref, onMounted } from 'vue'

var _ = require('lodash');
import axios from 'axios';

const props = defineProps([
  'rangeInit',
  'quoteInit',
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

import Adjusters from "@/components/builder/quote/Adjusters.vue";
import Totals from "@/components/builder/quote/Totals.vue";

import Sliding from "@/components/builder/products/wardrobes/sliding/Quote.vue";
import Sliding2 from "@/components/builder/products/wardrobes/sliding2/Quote.vue";
import Walkin from "@/components/builder/products/wardrobes/walkin/Quote.vue";
import Hinged from "@/components/builder/products/wardrobes/hinged/Quote.vue";
import Kitchen from "@/components/builder/products/kitchens/kitchen/Quote.vue";
import Laundry from "@/components/builder/products/laundries/laundry/Quote.vue";
import CustomKitchen from "@/components/builder/products/custom/Quote.vue";
import CustomLaundry from "@/components/builder/products/custom/Quote.vue";
import CustomWardrobe from "@/components/builder/products/custom/Quote.vue";
import Custom from "@/components/builder/products/custom/Quote.vue";

const comps = {
  Sliding,
  Sliding2,
  Walkin,
  Hinged,
  Kitchen,
  Laundry,
  CustomKitchen,
  CustomLaundry,
  CustomWardrobe,
  Custom
};

onMounted(() => {

  console.log(props.quoteInit)

  // initiate quote and items
  if (!_.isEmpty(props.quoteInit)) {
    builder.quoteId = props.quoteInit.id;
    builder.$patch((state) => {
      state.quote = props.quoteInit;
    })
    if (!_.isEmpty(props.quoteInit.items)) {
      builder.$patch((state) => {
        state.items = props.quoteInit.items;
      })
    }
  }

  // initiate range
  if (!_.isEmpty(props.rangeInit)) {
    builder.$patch((state) => {
      state.range = props.rangeInit;
    })
  }

});

function getComponent(item) {
  if (item.product) {
    return comps[item.product.handleCapitalised];
  }
  return false;
}

function lightboxActivate(dataSpec, handle) {

  let gallery = '';
  let description = '';
  let imageClass = '';
  if (handle == 'interior') imageClass = 'interior-image';

  if (['panel1', 'panel2', 'panel3', 'panel4'].indexOf(handle) !== -1) {

      let i = parseFloat(handle.replace(/^\D+/g, ''));

      if (!_.isUndefined(dataSpec.group) && _.isObject(dataSpec.group)) description += '<strong>' + dataSpec.group.title + ' ' + i + ':</strong> ';
      description += dataSpec.title;
      gallery = [{
        id: 1,
        content: '<img src="' + dataSpec.image + '" alt="" class="' + imageClass + '">'
      }];
    if (dataSpec.gallery.length) gallery = generateGallery(dataSpec.gallery);

  } else {

    if (!_.isUndefined(dataSpec.group) && _.isObject(dataSpec.group)) description += '<strong>' + dataSpec.group.title + ':</strong> ';
    description += dataSpec.title;
    gallery = [{
      id: 1,
      content: '<img src="' + dataSpec.image + '" alt="" class="' + imageClass + '">'
    }];
    if (dataSpec.gallery.length) gallery = generateGallery(dataSpec.gallery);

  }

  if (description.length) description = '<p style="text-align: center;">' + description + '</p>';

  lightbox.open(description, gallery);

  return false;

}

function generateGallery(galleryArray) {
  let gallery = [];
  for (let i = 0; i <= galleryArray.length; i ++) {
    gallery.push({
      id: i + 1,
      content: '<img src="' + galleryArray[i] + '" alt="" class="interior-image">'
    });
  }
  return gallery;
}

function showDeliveryExpanation() {
  lightbox.open(builder.delivery.details);
}


const dayjs = require('dayjs')
import dayjsBusinessDays from 'dayjs-business-days';
dayjs.extend(dayjsBusinessDays);

let now = dayjs()
const isNextBusinessDay = dayjs().format('H') > 17
const businessDays = 15 + ( isNextBusinessDay ? 1 : 0 )
const deliveryDateMin = now.businessDaysAdd(businessDays).format('YYYY-MM-DD')
const deliveryDateMax = now.businessDaysAdd(90).format('YYYY-MM-DD')
const deliveryDate = dayjs(builder.quote.deliveryDateRequest ?? deliveryDateMin).format('YYYY-MM-DD')
const deliveryDateValue = ref(deliveryDate)



</script>
